import { AspectRatio, Skeleton, Stack } from '@mantine/core'

export const LocationCardSkeleton = () => {
  return (
    <Stack>
      <AspectRatio ratio={4 / 3}>
        <Skeleton height={250} radius='lg' />
      </AspectRatio>

      <Skeleton height={30} w='70%' radius='lg' />
      <Stack gap={8}>
        <Skeleton height={20} radius='lg' />
        <Skeleton height={20} radius='lg' />
        <Skeleton height={20} radius='lg' />
      </Stack>
    </Stack>
  )
}
